import React from 'react';
import { Form, Input, Row, Col, Select, Switch, Space } from 'antd';
import global from '../../../../shared/utility/global';
import { DollarOutlined } from '@ant-design/icons';

const { TextArea } = Input;
const { Option } = Select;

export default function FormData(props) {
    return (
        <>
            <Form.Item name="productType" style={{ display: 'none' }}>
                <Input type="text" />
            </Form.Item>
            <Row gutter={20}>
                <Col span={24} className='mt-15'>
                    <Form.Item
                        label="Nombre"
                        name="name"
                        rules={[{ required: true, message: '' }]}
                        className='input-material'
                    >
                        <Input
                            size='large'
                            prefix={<></>}
                            placeholder="Ingresar nombre"
                            autoComplete="off"
                        />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="Precio"
                        name="price"
                        rules={[{ required: true, message: '' }]}
                        className='input-material'
                    >
                        <Input
                            size='large'
                            className="text-right"
                            prefix={<DollarOutlined />}
                            placeholder="Ingresar precio"
                            autoComplete="off"
                            onBlur={(e) => props.form.setFieldsValue({ price: global.onBlurDecimals(e.target.value, 2) })}
                        />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="Precio Antiguo"
                        name="oldPrice"
                        className='input-material'
                    >
                        <Input
                            size='large'
                            className="text-right"
                            placeholder="Ingresar precio antiguo"
                            autoComplete="off"
                            prefix={<DollarOutlined />}
                            onBlur={(e) => props.form.setFieldsValue({ oldPrice: global.onBlurDecimalsNullable(e.target.value, 2) })}
                        />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        label="Descripción"
                        name="description"
                        className='input-material'
                    >
                        <TextArea
                            placeholder="Ingresar descripción . . ."
                            autoComplete="off"
                            rows={4}
                        />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        label="Categorías"
                        name="categories"
                        className='input-material'>
                        <Select
                            size='large'
                            mode="multiple"
                            showSearch
                            allowClear
                            optionFilterProp="children"
                            placeholder="Seleccione categorías . . ."
                        >
                            {props.categories.map(item => (
                                <Option
                                    key={item.id}
                                    value={item.id}
                                    label={item.name}
                                >
                                    {item.name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        label="Etiquetas"
                        name="tags"
                        className='input-material'
                    >
                        <Select
                            mode="tags"
                            size='large'
                            showSearch
                            allowClear
                            optionFilterProp="children"
                            onInputKeyDown={e => e.key === 'Enter' && e.preventDefault()}
                            placeholder="Aregar etiquetas . . ."
                        >
                            {props.tags?.map(item => (
                                <Option
                                    key={item.id}
                                    value={item.id}
                                    label={item.name}
                                >
                                    {item.name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={24} lg={18} xl={14}>
                    <Space>
                        <Form.Item
                            className="free-shipping"
                            label={<span className='label-material'>Envío Gratis</span>}
                            name="freeShipping"
                            valuePropName="checked"
                        >
                            <Switch defaultChecked checkedChildren="SÍ" unCheckedChildren="NO" />
                        </Form.Item>
                        <Form.Item
                            label={<span className='label-material'>Visible</span>}
                            name="visible"
                            valuePropName="checked"
                        >
                            <Switch defaultChecked checkedChildren="SÍ" unCheckedChildren="NO" />
                        </Form.Item>
                    </Space>
                </Col>
            </Row>
        </>
    );
}